module.exports = __webpack_public_path__ + "img/garden_glzz_1.72bd26c8.png";